<template>
    <div class="bg-white shadow sm:rounded-lg max-w-xl mx-auto">
        <div class="px-4 py-5 sm:p-6">
            <h3 class="text-3xl font-black leading-6 text-gray-900 text-center">
                Boost your job listing reach
            </h3>
            <div class="mt-8 max-w-md prose mx-auto">
                    <div v-for="feature in product.features" class="flex flex-row items-center justify-center">
                        <svg class="h-6 w-6 text-green-500" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                        </svg>
                        <span class="ml-3 text-gray-600 font-medium">{{ feature }}</span>
                    </div>
            </div>
            <div class="my-12 leading-6 text-indigo-700 font-black text-center text-3xl">
                {{ price(product) }}
            </div>
            <div class="mt-5 sm:flex sm:items-center">
                <div class="max-w-md w-full mx-auto">

                    <div id="card-element" class="p-3 border rounded-md"></div>


                    <span class="mt-2 block w-full justify-between rounded-md shadow-sm text-center">
                        <button @click.prevent="upgrade()" id="card-button" type="button"
                                class="block w-full items-center px-4 py-2 border border-transparent
                        text-base leading-6 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500
                        focus:outline-none focus:border-indigo-700 focus:ring-indigo active:bg-indigo-700
                        transition ease-in-out duration-150">
                        Pay now
                        </button>
                    </span>

                    <div v-show="errors" class="mt-2 text-red-500" id="card-errors">{{ errors }}</div>
                </div>
                <span class="mt-3 inline-flex rounded-md shadow-sm sm:mt-0 sm:ml-3 sm:w-auto">
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import PostingLayout from "@/Jobroll/PostingLayout";

    export default {
        name: "PostingUpgrade",
        layout: PostingLayout,
        props: {
            lang: Object | String,
            client_secret: {type: String, required: true},
            product: Object,
            stripe_pk: {type: String, required: true},
            upgrade_id: {type: Number, required: true},
        },
        mounted() {

            this.$loadScript('https://js.stripe.com/v3/')
                .then(() => {

                    this.stripe = Stripe(this.stripe_pk);

                    const elements = this.stripe.elements();
                    this.cardElement = elements.create('card');

                    this.cardElement.mount('#card-element');


                    this.cardElement.on('change', ({error}) => {
                        if (error) {
                            this.errors = error.message;
                        } else {
                            this.errors = null;
                        }
                    });

                })
                .catch(() => {
                    // Failed to fetch script
                });

        },
        data() {
            return {
                cardElement: null,
                stripe: null,
                errors: null
            }
        },
        methods: {
            price(product) {
                return new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: product.currency.toUpperCase()
                }).format(product.price / 100);
            },
            upgrade() {
                this.stripe.confirmCardPayment(
                    this.client_secret, {
                        payment_method: {
                            card: this.cardElement
                        }
                    }
                ).then((result) => {
                        if (result.error) {
                            this.errors = result.error.message;
                        } else {
                            // The payment has been processed!
                            if (result.paymentIntent.status === 'succeeded') {
                                let data = new FormData();
                                data.append('pi', result.paymentIntent.id);
                                data.append('id', this.upgrade_id);
                                this.$inertia.post('/upgrade', data);
                            }
                        }
                    }
                );
            }
        }
    }
</script>
